import * as Fonts from './constants/fonts';
import * as Spacings from './constants/spacings';
import * as BgColors from './constants/colors/bgcolors';
import * as TextColors from './constants/colors/textcolors';
import * as BorderColors from './constants/colors/bordercolors';
import * as ShadowColors from './constants/colors/shadowcolors';

export const PRIMARY_BORDER_WIDTH = '1px';
export const SOLID_BORDER_STYLE = 'solid';
export const DASHED_BORDER_STYLE = 'dashed';

export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';

const mobile = {
  maxWidth: '540px'
};

const breakpoints = {
  mobile: '47.95em',
  tablet: '70.95em'
};

export {
  Fonts,
  BgColors,
  TextColors,
  BorderColors,
  ShadowColors,
  Spacings,
  mobile,
  breakpoints
};
